<template>
  <div>
    <div class="container container-sm">
      <div class="row justify-content-center section" style="margin: 0 auto">
        <div v-if="tokenFound">
          <Card class="mb-4">
            <template #title><h3 class="text24-blue">{{ t("CHOOSE_PASSWORD") }}</h3></template>
            <template #content>
              <p id="password-policy">
                {{ t("SAFE_PW") }}:<br/>
                - {{ t("MIN_15_CHARS") }}<br/>
                - {{ t("CHARS_NUMS") }}<br/>
                - {{ t("LC_UC") }}<br/>
                - {{ t("NO_PERSONAL_DATA") }}<br/>
                - {{ t("NO_VOCABULARY") }}<br/>
              </p>

              <form novalidate @submit.prevent="setPassword">
                <div class="mb-2">
                  <InputText
                      class="w-100"
                      type="password"
                      :placeholder="t('PASSWORD')"
                      name="password1"
                      id="password1"
                      v-model="form.passwordFirst"
                      :invalid="!isStrongPassword && startValidation"
                  />
                  <small v-show="!isStrongPassword && startValidation" class="text-danger">{{ t("INVALID_PW_PASSWORD") }}</small>
                </div>

                <div class="mb-2">
                  <InputText
                      class="w-100"
                      required
                      name="password2"
                      id="password2"
                      type="password"
                      :placeholder="t('PASSWORD_AGAIN')"
                      v-model="form.passwordSecond"
                      :invalid="!isPasswordMatches && startValidation"
                  />
                  <small v-show="!isPasswordMatches && startValidation" class="text-danger">{{ t("PW_MISMATCH") }}</small>
                </div>

                <div class="mb-2 mt-4">
                  <Button type="submit" :disabled="!isPasswordValid" :label="t('SAVE')" class="blue w-100"/>
                </div>
              </form>
            </template>
          </Card>
        </div>

        <div v-show="expired" class="alert alert-danger">{{ t("TOKEN_EXPIRED") }}</div>
      </div>

      <div class="separator-line"></div>

      <div class="row justify-content-center mt-4">
        <router-link :to="{ name: 'Login' }" class="p-button mb-4">{{ t("BACK") }}</router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted, ref} from 'vue';
import {injectAxios} from "@/util/inject";
import {useI18n} from 'vue-i18n';
import {useRoute, useRouter} from 'vue-router';
import {useToast} from "@/util/toastUtils";

const router = useRouter();
const {t} = useI18n();
const toast = useToast();
const axios = injectAxios();
const route = useRoute();
const tokenFound = ref(false);
const expired = ref(false);
const form = ref({
  passwordFirst: '',
  passwordSecond: '',
});
const startValidation = ref(false);

onMounted(async () => {
  if (route.query.token) {
    await checkToken(route.query.token);
  } else {
    await router.push({path: '/'});
  }
});

const isStrongPassword = computed(() => {
  return /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d)(?=.*?[^\w\s]).{15,}$/.test(form.value.passwordFirst);
});

const isPasswordMatches = computed(() => {
  return form.value.passwordFirst === form.value.passwordSecond;
});

const isPasswordValid = computed(() => {
  return isStrongPassword.value && isPasswordMatches.value;
});

const checkToken = async (token) => {
  const response = await axios.post(`/account/token-valid`, {
    token: token,
  });
  tokenFound.value = response.data.valid;
  expired.value = !response.data.valid;
};

const setPassword = async () => {
  startValidation.value = true;
  if (!isPasswordValid.value) {
    toast.makeErrorToast(t("CHECK_INPUT"));
    return;
  }
  await axios.put(`/account/password-reset`, {
    token: route.query.token,
    password: form.value.passwordFirst,
  });
  toast.makeSuccessToast(t("OPERATION_SUCCESSFUL"));
  form.value.passwordFirst = "";
  form.value.passwordSecond = "";
  tokenFound.value = false;
};
</script>
